import React, { Component } from "react";
import "./App.css";
import * as tf from "@tensorflow/tfjs";
import yolo, { downloadModel } from "tfjs-yolo-tiny";
import { Button } from 'react-bootstrap';
import Typed from 'react-typed';

import ReactGA from 'react-ga';

import AFrameApp from "./AFrameApp";

class App extends Component {
  constructor(props) {
    super(props);
    this.logToDiv = null;
    this.model = null;
    this.videoElement = null;
    this.aframeCamera = null;
    this.aframeAnimation = null;
    this.stillRuning = false;
    this.modelLoaded = false;
    this.aiFpsDiv = null;

    this.intrestPointList = [];
    this.minMoveDistance = 15; //px
    this.minWaitingTime = 0.2 // seconds
    this.errorMessages = [];

    this.state = {
      boxesState: null,
      failedFeatureCheck: false,
      appState: 0, //0: Initing Page, 1: Ready to play video, 2: Video playing, 3: AI runing, 4: Stoped, -1: can not be view
      aiState: 0 //0: Waiting, 1: Loading models, 2: Running, 3: Stoped
    };
  }

  /**************
   * Begin: Controlling Section
   **************/

  videoFrameLoaded = (evt) => {
    //console.log('Video frame loaded');
    if (this.state.appState === 0) {
      this.setState({ appState: 1 });
      this.typed.toggle()
    }
  }

  videoPlaying = (evt) => {
    //console.log('Video playing');
    this.setState({ appState: 2 });
  }

  loadModelAndRun = () => {
    if (!this.modelLoaded) this.initTiny();
    else this.runModel();
  };

  playVideo = () => {
    this.stillRuning = true;
    this.videoElement.play();
  };

  stopVideo = () => {
    this.videoElement.pause();
    this.stillRuning = false;
    this.setState({
      appState: 4,
      aiState: 3
    });
  };

  logPeformance(t0, t1) {
    // console.log(`Dection time: ${t1 - t0} ms`);
    this.aiFpsDiv.innerHTML = `AI: ${Math.floor(1000 / (t1 - t0))} fps`
    //console.log("tf.memory(): ", tf.memory());
  }

  featureCheck() {
    if (this.mobileCheck()) {
      this.errorMessages.push("This demo does not work on mobile devices.");
    }

    /* global Modernizr */
    //console.log(Modernizr);
    if (Modernizr.video) {
      if (Modernizr.video.h264 !== "probably") {
        this.errorMessages.push("HTML Video tag supported but H264 video may not play.");
      }
    } else {
      this.errorMessages.push("HTML Video tag not supported.");
    }

    if (!Modernizr.webgl) {
      this.errorMessages.push("WebGL is not supported. This is needed for VR and AI acceleration.");
    }

    if (tf.getBackend() === "cpu") {
      this.errorMessages.push("Tensorflow is using CPU backend, not suitable for live video dectetion.");
    }


    if (this.errorMessages.length !== 0) {
      this.setState({ failedFeatureCheck: true });
    }
  }

  mobileCheck() {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };

  /**************
   * End: Controlling Section
   **************/

  /**************
   * Begin: Rendering Section
   **************/

  componentDidMount() {
    this.videoElement = document.getElementById("mainVideo");
    this.aiFpsDiv = document.getElementById("aiFpsDiv");
    this.aframeCamera = document.getElementsByClassName("aframeCam")[0];
    this.aframeAnimation = document.getElementsByClassName("aframeAni")[0];

    ReactGA.initialize('UA-131386876-1');
    ReactGA.pageview(window.location.pathname + window.location.search);

    setTimeout(this.featureCheck(), 1000);
  }


  renderAFrame() {
    if (this.state.failedFeatureCheck) {
      return <div />;
    } else if (this.state.appState >= 1) {
      return <AFrameApp isMouseMove={false} hidden={this.state.failedFeatureCheck} />;
    } else {
      return <img id="loading" src="/loading-1s-200px.svg" ></img>;
    }
  }

  render() {
    return (
      <div className="App" id="mainApp">
        <div id="rawData" style={this.state.failedFeatureCheck? { display: "none" } : {}}>
          <div id="info" className="padded">
            <Typed
              typedRef={(typed) => { this.typed = typed; }}
              strings={['A short demo using ML to navigate a 360 video.',
                'A short demo using ML to navigate a VR video.',
                'The picture below show raw VR video data',
                'Click on it to manually look around.',
                'Click on the buttons to get started.',
                'The red dots show where the AI want to look.']}
              backDelay={3000}
              typeSpeed={40}
              backSpeed={25}
              smartBackspace={true}
              stopped={true}
            />
          </div>
          <div
            style={{ width: "416px", height: "416px" }}
            id="imgContatiner"
            onClick={this.getCordOf416}
          >
            <video
              src="/data_equ/halibut.mp4"
              id="mainVideo"
              width="416"
              height="416"
              crossOrigin="anonymous"
              preload="auto"
              playsInline
              loop

              onLoadedData={this.videoFrameLoaded}
              onPlay={this.videoPlaying}
            >
              <source type="video/mp4" src="/data_equ/halibut.mp4" />
            </video>
            <canvas id="mainCanvas" width="416" height="416">
              {" "}
            </canvas>
          </div>
          <div id="controls" className="padded">
            <Button onClick={this.playVideo}
              bsStyle='info'
              disabled={this.state.appState !== 1}>
              1. Play Video
              </Button>
            <Button onClick={this.state.appState <= 3 ? this.loadModelAndRun : null}
              disabled={this.state.appState !== 2}
              bsStyle='success'
            >2. Load & Run AI</Button>
            <Button onClick={this.stopVideo}
              bsStyle='danger'
              disabled={this.state.appState !== 3 || this.state.appState === 4}>3. Stop</Button>
          </div>
          <div id="statsDiv" >
            <div id="playerFpsDiv" className="stat padded">Render: none</div>
            <div id="aiFpsDiv" className="stat padded">AI: none</div>
          </div>
        </div>
        {this.renderAFrame()}
        <div id="notSupported" style={this.state.failedFeatureCheck? {}: { display: "none" } }>
          <h2>{this.errorMessages[0]}</h2>
          <h3>Try again on Chrome on a PC with GPU.</h3>
          <h3>Or check out a recording of the page here:</h3>
          <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/1gSvzvILiwU" frameBorder="0"></iframe>
        </div>
      </div>
    );
  }

  getCetenter(box) {
    var { left, right, top, bottom } = box;
    return {
      x: (right + left) * 0.5,
      y: (bottom + top) * 0.5
    };
  }

  getMiddlePoint(p1, p2) {
    return {
      x: (p1.x + p2.x) * 0.5,
      y: (p1.y + p2.y) * 0.5
    };
  }

  drawRect(x, y, w, h, center = false, text = "", color = "blue") {
    var c = document.getElementById("mainCanvas");
    var ctx = c.getContext("2d");
    if (!center) {
      ctx.beginPath();
      ctx.lineWidth = "3";
      ctx.strokeStyle = "red";
      //console.log(" " + x + " " + y + " " + w + " " + h);
      ctx.rect(x, y, w, h);
      ctx.stroke();
    } else {

      ctx.beginPath();
      ctx.lineWidth = "3";
      ctx.strokeStyle = "red";
      ctx.arc(x, y, 4, 0, 2 * Math.PI);
      ctx.stroke();
    }
  }

  clearRect() {
    var c = document.getElementById("mainCanvas");
    var ctx = c.getContext("2d");
    ctx.clearRect(0, 0, 416, 416);
  }

  drawIntrestPoints() {
    this.clearRect();
    for (const point of this.intrestPointList) {
      this.drawRect(point.x, point.y, 0, 0, true);
    }
  }

  /**************
   * End: Rendering Section
   **************/

  /**************
   * Begin: AI Section
   **************/

  async initTiny() {
    this.aiFpsDiv.innerHTML = "AI: Initing...";
    this.setState({ aiState: 1 });
    this.model = await downloadModel();
    this.runModel();
  }

  async runModel() {
    this.modelLoaded = true;
    this.setState({ appState: 3, aiState: 2 });
    while (this.stillRuning) {
      //console.log(this.state.appState);
      const t0 = performance.now();

      //var processedData = this.processFrame(this.imageElement);
      var processedData = await this.processFrame(this.videoElement);
      //console.log(processedData);

      const boxes = await yolo(processedData, this.model, {
        width: 416,
        height: 416,
        filterBoxesThreshold: 0.3
      });

      processedData.dispose();

      const t1 = performance.now();

      this.logPeformance(t0, t1);

      if (boxes != null) {
        this.lookAtPoint(boxes);
      }

      // console.log("Done");
      // console.log(this.state.boxesState);
      await tf.nextFrame();
    }
    this.aiFpsDiv.innerHTML = "AI: Stoped";
  }

  async processFrame(inputElement) {
    var imageData = tf.fromPixels(inputElement);
    //const imageData = this.cropImage(imageData);
    imageData = imageData.expandDims(0);
    return imageData.toFloat().div(tf.scalar(255));
  }

  isBoxImportant(box, high = false) {
    var size = (box.right - box.left) * (box.bottom - box.top);
    // console.log(`${box.className} of prob ${box.classProb} is of size ${size}`);
    if (!high) return box.classProb >= 0.5 && size >= 500;
    else return box.classProb >= 0.6 && size >= 700;
  }
  /**************
   * End: AI Section
   **************/

  /**************
   * Begin: Logic Section
   **************/
  pickPointToLook(boxes) {
    var i = 0;
    var center;
    var average;
    var haveResult = false;

    for (; i < boxes.length; i++) {
      const box = boxes[i];

      if (this.isBoxImportant(box, true)) {
        if (!haveResult) {
          average = this.getCetenter(box);
          haveResult = true;
        } else {
          center = this.getCetenter(box);
          average = this.getMiddlePoint(center, average);
        }
      }
    }
    if (haveResult) {
      average = {
        x: average.x,
        y: average.y,
        haveResult: haveResult
      };
    } else {
      average = { x: 0, y: 0, haveResult: haveResult };
    }

    average = this.dizzyControl(average);
    // this.drawRect(average.x, average.y, 0, 0, true);
    this.addIntrestPoints(average);
    // console.log(`Want to see ${top/i}, ${left/i}, ${right/i}, ${bottom/i}`);
    //this.clearRect();
    return average;
  }

  lookAtPoint(boxes) {
    var pointEqu = this.pickPointToLook(boxes);
    if (pointEqu.haveResult) {
      var point = this.equToDeg(pointEqu.x, pointEqu.y);
      // this.aframeCamera.setAttribute(
      //   "rotation",
      //   `${point.pitch} ${point.yaw} 0`
      // );
      window.dispatchEvent(new CustomEvent("lookAtP", { detail: point }));
    }
  }

  getCordOf416 = evt => {
    var rect = this.videoElement.getBoundingClientRect();
    var x = evt.clientX - rect.left;
    var y = evt.clientY - rect.top;
    // console.log(`Click at X: - ${x} Y: ${y}`);

    var point = this.equToDeg(x, y);

    window.dispatchEvent(new CustomEvent("lookAtP", { detail: point }));

  }
  addIntrestPoints(point) {
    const maxLength = 30;
    point.videoTime = this.videoElement.currentTime;
    this.intrestPointList.push(point);

    if (this.intrestPointList.length >= maxLength) {
      this.intrestPointList.shift();
    }

    this.drawIntrestPoints();
  }

  dizzyControl(point) {
    const length = this.intrestPointList.length;
    if (length > 1) { // ignore if first point
      const lastPoint = this.intrestPointList[length - 1];
      const dX = Math.abs(point.x - lastPoint.x);
      const dY = Math.abs(point.y - lastPoint.y);

      const farEnough = dX + dY > this.minMoveDistance;
      var waitedLongEnough = true;
      if (farEnough < this.minMoveDistance * 3) {
        waitedLongEnough = this.videoElement.currentTime - lastPoint.videoTime > this.minWaitingTime;
      }
      return farEnough && waitedLongEnough ? point : lastPoint;
    } else {
      return point;
    }
  }

  equToDeg(x, y, w = 416, h = 416) {
    var rotation = { pitch: 0, yaw: 0 };

    rotation.yaw = -360 * ((x - w / 2) / w);
    rotation.pitch = -180 * ((y - h / 2) / h);
    return rotation;
  }
  /**************
   * End: Logic Section
   **************/

}
export default App;
